import { Link } from 'react-router';

export interface Crumb {
  label: string;
  /** Omitted (or on the last item, ignored) means plain text — the current page never links. */
  to?: string;
}

/**
 * Breadcrumb trail for a page nested under a section (D12): e.g. Admin / Report detail. Renders
 * nothing when there is no trail, so pages that never pass `items` are unaffected.
 */
export function Breadcrumbs({ items }: { items?: readonly Crumb[] }) {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb">
      <ol className="m-0 flex list-none flex-wrap items-center gap-1.5 p-0 text-sm text-ink-2">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${c.label}-${i}`} className="flex items-center gap-1.5">
              {i > 0 ? (
                <span aria-hidden="true" className="text-ink-3">
                  /
                </span>
              ) : null}
              {!last && c.to ? (
                <Link to={c.to} className="hover:text-ink hover:underline">
                  {c.label}
                </Link>
              ) : (
                <span aria-current={last ? 'page' : undefined} className={last ? 'font-medium text-ink' : undefined}>
                  {c.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
